import { render, staticRenderFns } from "./siteinfo.vue?vue&type=template&id=7b45bb7b"
import script from "./siteinfo.vue?vue&type=script&lang=js"
export * from "./siteinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports